// extracted by mini-css-extract-plugin
var _1 = "EntityLink-moduleEntityLink__AOulJ";
var _2 = "EntityLink-moduledone__QQ0_p";
var _3 = "EntityLink-moduleunread__mBwrE";
export { _1 as "EntityLink", _2 as "done", _3 as "unread" }
